import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DataTaskChart } from '../../../domain/data-task-chart';
import { DashboardCardComponent } from '../dashboard-card/dashboard-card.component';

@Component({
   selector: 'app-dashboard-tasks',
   standalone: true,
   imports: [CommonModule, DashboardCardComponent],
   templateUrl: './dashboard-tasks.component.html',
   styleUrls: ['./dashboard-tasks.component.scss']
})
export class DashboardTasksComponent {
   @Input() tasks: DataTaskChart[] = [];
   @Input() loading = false;
   @Input() error = false;

   expanded = false;

   get sortedTasks(): DataTaskChart[] {
      return [...this.tasks].sort(
         (a, b) => this.getOutstanding(b) - this.getOutstanding(a)
      );
   }

   get visibleTasks(): DataTaskChart[] {
      return this.expanded ? this.sortedTasks : this.sortedTasks.slice(0, 5);
   }

   get hasMoreTasks(): boolean {
      return this.tasks.length > 5;
   }

   getOutstanding(task: DataTaskChart): number {
      return Math.max(task.totalTasks - task.completed, 0);
   }

   getCompletionPercentage(task: DataTaskChart): number {
      if (task.totalTasks <= 0) {
         return 0;
      }

      return Math.round((task.completed / task.totalTasks) * 100);
   }

   toggleExpanded(): void {
      this.expanded = !this.expanded;
   }
}
